import styled from 'styled-components';

export const HotelsTableContainer = styled.div`
  min-height: var(--spacing-screen-height);
  // min-height: 92vh;
  padding: var(--spacing-6) var(--spacing-12);
  position: relative;
  box-sizing: border-box;
  max-width: 100%;
  // overflow-x: hidden;
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

export const TableLabel = styled.div`
  background-color: var(--color-primary-600);
  border-radius: 9999px;
  padding: var(--spacing-1) var(--spacing-4);

  h1 {
    color: white;
  }
`;

export const StatusFiltersContainer = styled.div`
  display: flex;
  gap: var(--spacing-4);
  align-items: center;
`;

export const SortContainer = styled.div`
  display: flex;
  gap: var(--spacing-2);
  align-items: center;
  justify-content: center;

  h1 {
    /* Default heading styles */
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  width: 300px; /* Default width */

  /* Allow width to be overridden by className */
  &.w-24 {
    width: 6rem;
  }
  &.w-32 {
    width: 8rem;
  }
  &.w-40 {
    width: 10rem;
  }
  &.w-48 {
    width: 12rem;
  }
  &.w-56 {
    width: 14rem;
  }
  &.w-64 {
    width: 16rem;
  }
  &.w-72 {
    width: 18rem;
  }
  &.w-80 {
    width: 20rem;
  }
  &.w-96 {
    width: 24rem;
  }
`;

export const SearchInputContainer = styled.div`
  position: relative;
`;

export const SearchIconWrapper = styled.div`
  position: absolute;
  left: var(--spacing-3);
  top: 50%;
  transform: translateY(calc(-50% - 0.5px));
  color: var(--color-gray-400);
`;

export const ClearSearchButton = styled.div`
  position: absolute;
  right: var(--spacing-3);
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
`;

export const SearchLoaderWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: var(--spacing-3);
  transform: translateY(-50%);
`;

export const ClearFiltersButton = styled.button`
  font-size: var(--font-size-sm);
  color: var(--color-gray-600);
  transition: var(--transition-fast);

  &:hover {
    color: var(--color-gray-900);
  }
`;

export const TableWrapper = styled.div`
  width: 100%;
  position: relative;
`;

export const LoadingTableBody = styled.tbody``;

export const LoadingTableRow = styled.tr``;

export const LoadingTableCell = styled.td<{
  $alignCenter?: boolean;
  $hasLoader?: boolean;
}>`
  text-align: ${props => (props.$alignCenter ? 'center' : 'left')};
  position: relative;
  height: 200px;

  ${props =>
    props.$hasLoader &&
    `
    .loader-container {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `}
`;

export const HotelInfoContainer = styled.div`
  flex: 1;
  min-width: 0; /* Allow flex item to shrink below its content size */
  max-width: 400px; /* Set a maximum width for the text container */
`;

export const HotelNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  margin-bottom: var(--spacing-1);
`;

export const HotelName = styled.p`
  font-weight: 500;
  color: var(--color-gray-900);
  font-size: var(--font-size-sm);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const HotelLocation = styled.p`
  font-size: var(--font-size-xs);
  color: var(--color-gray-500);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const HotelBrandInfo = styled.p`
  font-size: var(--font-size-xs);
  color: var(--color-gray-400);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const NoScoreText = styled.span`
  color: var(--color-gray-400);
  text-align: center;
`;

export const NoDataText = styled.span`
  color: var(--color-gray-400);
`;

export const NoHotelsText = styled.span`
  color: var(--color-gray-500);
`;

export const PaginationContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  float: right;
  margin-top: var(--spacing-3);
`;

export const PaginationShowingText = styled.span`
  color: var(--color-gray-500);
  font-weight: 500;
  margin-right: var(--spacing-4);
`;

export const PaginationTotalText = styled.h1`
  color: var(--color-gray-500);
  font-weight: 600;
  margin-right: var(--spacing-3);
`;

export const PaginationButton = styled.button<{ $disabled?: boolean }>`
  cursor: ${props => (props.$disabled ? 'not-allowed' : 'cursor')};

  &:disabled {
    color: var(--color-gray-100);
  }
`;

export const CurrentPageIndicator = styled.span`
  color: var(--color-gray-500);
  font-weight: 500;
  background-color: var(--color-gray-100);
  border-radius: var(--radius-sm);
  padding: var(--spacing-1) var(--spacing-3);
  margin: 0 var(--spacing-1);
  text-align: center;
`;
